module.exports = "pegasus/assets/blocks/image-2-tech.png";